import { OFFER_API_DATA } from './reducer';
import { BUSINESS_CURRENT_ACCOUNT } from '../../utils/constants';

const FPS_PAYMENT_TYPE = 'FPS';

export const isBasicBusinessAccount = state => {
  const offers = state.offers.get(OFFER_API_DATA);
  const caseData = state.dataCapture.get('caseData');
  return (
    offers &&
    caseData &&
    offers.product.name &&
    caseData.product.type &&
    offers.product.name.toLowerCase() === caseData.product.type.toLowerCase()
  );
};

export const getBusinessAccount = state => {
  const offers = state.offers.get(OFFER_API_DATA);
  return offers && offers.product && offers.product.name;
};

export const isBusinessCurrentAccount = state => {
  const account = getBusinessAccount(state);
  return account && account.toLowerCase() === BUSINESS_CURRENT_ACCOUNT.toLowerCase();
};
export const getDailyLimit = state => {
  const offers = state.offers.get(OFFER_API_DATA);
  return offers &&
    offers.features &&
    offers.features.payment_limits &&
    offers.features.payment_limits.daily_limit &&
    offers.features.payment_limits.daily_limit > 0
    ? `£${offers.features.payment_limits.daily_limit}`
    : '';
};
export const getTransactionLimit = state => {
  const offers = state.offers.get(OFFER_API_DATA);
  const transactionLimit =
    offers &&
    offers.features &&
    offers.features.payment_limits &&
    offers.features.payment_limits.transaction_limit &&
    offers.features.payment_limits.transaction_limit.length > 0
      ? getLimitValue(offers.features.payment_limits.transaction_limit)
      : '';
  return transactionLimit && transactionLimit.length > 0 && transactionLimit[0].limit > 0
    ? `£${transactionLimit[0].limit}`
    : '';
};

const getLimitValue = transaction_limit =>
  transaction_limit.filter(value => value.payment_type === FPS_PAYMENT_TYPE && value.limit);
